import { FullscreenExitOutlined, FullscreenOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Button, Card, Grid, Modal, Space, Tooltip, Typography } from 'antd';
import { type ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import LoadingElement from '../../../../components/LoadingElement';

const Title = styled(Typography.Title)`
    text-align: center;
`;

export const FullScreenModal = styled(Modal)`
    width: 100vw;
    margin: 0;
    & .ant-modal {
        margin: 0;
    }
    & .ant-modal-content {
        width: 100vw;
        margin: 0;
        top: 0;
    }
`;

type FullScreenWrapperProps = {
    title: string;
    tooltip?: string;
    isLoading?: boolean;
    disabledFullScreen?: boolean;
    children: JSX.Element | ReactNode;
    height?: number | 'auto';
};

export const FullScreenWrapper = ({
    title,
    tooltip,
    isLoading,
    disabledFullScreen,
    children,
    height = 'auto',
}: FullScreenWrapperProps) => {
    const { t } = useTranslation(['dashboard']);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const screens = Grid.useBreakpoint();

    const showModal = useCallback(() => {
        setIsFullScreen(true);
    }, [setIsFullScreen]);

    const hideModal = useCallback(() => {
        setIsFullScreen(false);
    }, [setIsFullScreen]);

    if (isLoading) {
        return <LoadingElement />;
    }

    return (
        <div>
            <FullScreenModal
                closeIcon={<FullscreenExitOutlined />}
                footer={null}
                onCancel={hideModal}
                open={isFullScreen}
                title={null}
            >
                <Title level={4}>{title}</Title>
                {children}
            </FullScreenModal>
            <Card
                extra={
                    <Button disabled={disabledFullScreen} onClick={showModal} style={{ padding: '4px' }} type="link">
                        {screens.md && t('dashboard:fullScreen')}
                        <FullscreenOutlined disabled={disabledFullScreen} onClick={showModal} />
                    </Button>
                }
                style={{ height }}
                title={
                    <Space>
                        {title}
                        {tooltip && (
                            <Tooltip title={tooltip}>
                                <InfoCircleFilled />
                            </Tooltip>
                        )}
                    </Space>
                }
            >
                {children}
            </Card>
        </div>
    );
};
